// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3469":"css/app.6714","6024":"css/admin-app.6714"}[chunkId] + ".css";
};